import ChartTab from "./ChartTab";
import React from "react";
import moment from "moment";
import { stringify } from "querystring";
// import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartTaxTabPure extends React.Component {
  render() {
    const { data } = this.props;

    // let pivots = ["taxName", "rate"];
    // let showColumns = ["taxName", "rate", "date", "baseHT", "amount"];

    let pivots = ["taxLabel", "type", "taxTaux", "dateMonthYear"]; //, "rate"];
    let showColumns = [
      "taxLabel",
      "type",
      "taxTaux",
      "dateMonthYear",
      "paymentDate",
      "tiersName",
      "operationDate",
      // "family",
      "baseHT",
      "amount",
      "taxTotalTTC"
    ]; // "rate", "date", "baseHT", "amount"];

    // console.log("28 - P=", this.props);

    const burdenStr = this.props.intl.formatMessage({ id: "ids_burden" });          // charges
    const investmentStr = this.props.intl.formatMessage({ id: "ids_investment" });  
    const invoiceStr = this.props.intl.formatMessage({ id: "ids_sales" });
    const bankTransactionStr = this.props.intl.formatMessage({ id: "ids_payment" });

    if (!!data)
      for (let line of data) {
        line.dateMonthYear = moment(line.paymentDate).format("YYYY-MM");

        // console.log("44 - line=", line);

        if (line.expenseId) {
          // check investment familly
          if (
            line.category &&
            line.category.categoryFamily &&
            line.category.categoryFamily.ids ===
            "ids_immobilisationsEtInvestissements"
          ) {
            line.type = investmentStr;
          } else {
            line.type = burdenStr;
          }
        }
        if (line.invoiceId) {
          line.type = invoiceStr;

          if (line.taxType !== undefined && line.taxType !== "NONE") {
            const mode = line.taxType === "DEBIT" ? this.props.intl.formatMessage({ id: "ids_debit" }) : this.props.intl.formatMessage({ id: "ids_encaissement" });
            line.type = line.type + " (" + mode + ")";
          }
        }
        if (line.bankTransactionId) {
          // console.log("65 - line=", line);
          line.type = bankTransactionStr;

          if (
            line.category &&
            line.category.ids ===
            "ids_taxesDeductiblesSurBiensEtServices"
          ) {
            line.type = burdenStr;
          }
          else if ( line.category.categoriesParent !== undefined && line.category.categoriesParent.ids === "ids_taxesDeductiblesSurBiensEtServices") {
            line.type = burdenStr;
          }
          else if (
            line.category &&
            line.category.ids ===
            "ids_taxesSurVentes"
          ) {
            line.type = invoiceStr;

            if (line.taxType !== undefined && line.taxType !== "NONE") {
              const mode = line.taxType === "DEBIT" ? this.props.intl.formatMessage({ id: "ids_debit" }) : this.props.intl.formatMessage({ id: "ids_encaissement" });
              line.type = line.type + " (" + mode + ")";
            }
          }
          else if ( line.category.categoriesParent !== undefined && line.category.categoriesParent.ids === "ids_taxesSurVentes") {
            line.type = invoiceStr;

            if (line.taxType !== undefined && line.taxType !== "NONE") {
              const mode = line.taxType === "DEBIT" ? this.props.intl.formatMessage({ id: "ids_debit" }) : this.props.intl.formatMessage({ id: "ids_encaissement" });
              line.type = line.type + " (" + mode + ")";
            }
          }
        }

        // if (line.category && line.category.categoryFamily.ids) {
        //   line.category.categoryFamily.name = intl.formatMessage({
        //     id: line.category.ids
        //   });
        // }
      }

    // console.log("62 - DATA=", JSON.stringify(data, null, 2));

    return (
      <ChartTab
        {...this.props}
        data={data}
        // defaultPageSize={computeDefaultTableSize(data, "tiersClient")}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showExtra={false}
        defaultSorted={[
          {
            id: "type",
            desc: true
          },
          {
            id: "dateMonthYear",
            desc: false
          },
          {
            id: "taxLabel",
            desc: false
          },
          {
            id: "type",
            desc: true
          },
          {
            id: "taxTaux",
            desc: false
          },
          {
            id: "dateMonthYear",
            desc: false
          },
          {
            id: "tiersName",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartTaxTabPure;
